import React from "react";
import Header from "./component/Header";
import Footer from "./component/Footer";
import AppRouter from "./AppRouter";

function App() {
  return (
    <>
    <Header />
    <AppRouter />
    <Footer />                                
    </>
  );
}

export default App;
